<template>
	<div id="app" class="numerologyContainer">

				<!-- <h1>Numerology</h1>
				<p>Here you can see which numeric values your names have. Enter the name into the box below and see if they match the numeric values of your clean numeric keypad.</p>
				<p>The proverbial alphabet is built on Old Persian alphabet the caption. The alphabet is as follows:
				</p> -->
				<table>
								<tr>
										<th>1</th>
										<th>2</th>
										<th>3</th>
										<th>4</th>
										<th>5</th>
										<th>6</th>
										<th>7</th>
										<th>8</th>
								</tr>
								<tr>
										<td>A</td>
										<td>B</td>
										<td>C</td>
										<td>D</td>
										<td>E</td>
										<td>U</td>
										<td>O</td>
										<td>F</td>
								</tr>
								<tr>
										<td>I</td>
										<td>K</td>
										<td>G</td>
										<td>M</td>
										<td>H</td>
										<td>V</td>
										<td>Z</td>
										<td>P</td>
								</tr>
								<tr>
										<td>J</td>
										<td>R</td>
										<td>L</td>
										<td>T</td>
										<td>N</td>
										<td>W</td>
										<td>Ø</td>
										<td>&nbsp;</td>
								</tr>
								<tr>
										<td>Q</td>
										<td>&nbsp;</td>
										<td>S</td>
										<td>&nbsp;</td>
										<td>X</td>
										<td>Æ</td>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
								</tr>
								<tr>
										<td>Y</td>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
								</tr>
								<tr>
										<td>Å</td>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
										<td>&nbsp;</td>
								</tr>
				</table>

				<div v-html="customText">{{customText}}</div>

				<form>
					<div>
						<label>{{t('Indtast Ord / Navn')}}:</label>
						<input type="text" @input="convertInput" v-model="name">
					</div>
					<div>
						<label>{{t('Hele værdien')}}</label>
						<div class="numerology-calc">
							<span v-html="totalCalc"></span>
						</div>
						<!-- <input id='hele' type="text" disabled v-model="totalCalc"> -->
					</div>
					<div>
						<label>{{t('Konsonant')}}</label>
						<div class="numerology-calc">
							<span v-html="konsonantCalc"></span>
						</div>
					</div>
					<div>
						<label>{{t('Vocal')}}</label>
						<div class="numerology-calc">
							<span v-html="vocalCalc"></span>
						</div>
					</div>
				</form>

	</div>
</template>

<script>

	export default {
		name: 'NumerologyComponent',
		data () {
    		return {
				total: [0],
				totalDigits: [0],
				totalCalc: '',
				konsonant: [0],
				konsonantDigits: [0],
				konsonantCalc: '',
				vocal: [0],
				vocalDigits: [0],
				vocalCalc: '',
				charNums: {
						  "A": 1,
						  "I": 1,
						  "J": 1,
						  "Q": 1,
						  "Y": 1,
						  "Å": 1,
						  "B": 2,
						  "K": 2,
						  "R": 2,
						  "C": 3,
						  "G": 3,
						  "L": 3,
						  "S": 3,
						  "D": 4,
						  "M": 4,
						  "T": 4,
						  "E": 5,
						  "H": 5,
						  "N": 5,
						  "X": 5,
						  "U": 6,
						  "V": 6,
						  "W": 6,
						  "Æ": 6,
						  "O": 7,
						  "Z": 7,
						  "Ø": 7,
						  "F": 8,
						  "P": 8
						},
				name: '',
				customText: ''
			}
		},
		mounted() {
			if (typeof window.locale !== 'undefined') {
		        this.$translate.setLang(window.locale);
		    }

			this.totalCalc = '0/0';
			this.konsonantCalc = '0/0';
			this.vocalCalc = '0/0';

			if (typeof window.customText !== 'undefined') {
				this.customText = window.customText;
			}
		},

	methods:{
			getDigitSum(value) {
				let sum = 0;
				while (value) {
				    sum += value % 10;
				    value = Math.floor(value / 10);
				}
				value = sum;
				return sum
			},

			sumDigits(numbers) {
				var sum = [];
				for(var i=0; i < numbers.length; i++) {
					sum.push(0);
					let value = numbers[i];
					sum[i] = this.getDigitSum(value);
					if (sum[i] > 9) {
						sum[i] = this.getDigitSum(sum[i]);
					}
				}

				return sum;
			},

	  		calcTotalNum: function(subname){
	  			let calcTotal = 0
  				for(var i=0; i < subname.length; i++) {
					calcTotal += this.charNums[subname[i]] || 0;
				}
				return calcTotal;
	  		},

	  		calcKonsonantNum: function(subname) {
	  			let calcKonsonant = 0;

	  			let konsonantLetters = ["J","Q","B","K","R","C","G","L","S","D","M","T","H","N","X","V","W","Z","F","P"];
	  			for(var i=0; i < subname.length; i++) {
	  				if(konsonantLetters.includes(subname[i]) ){
						calcKonsonant += this.charNums[subname[i]] || 0;
	  				}
				}
				return calcKonsonant;
	  		},

	  		calcVocalNum: function(subname) {
	  			let calcVocal = 0;

	  			let VocalLetters = ["A","I","Y","Å","E","U","Æ","O","Ø"];
	  			for(var i=0; i < subname.length; i++) {
	  				if(VocalLetters.includes(subname[i]) ){
						calcVocal += this.charNums[subname[i]] || 0;
	  				}
				}
				return calcVocal;
	  		},

	  		calcNumbers: function(name) {
				let calcTotal = [];
				let calcKonsonant = [];
				let calcVocal = [];

  				name = name.split(" ");
  				for (var j = 0; j < name.length; j++) {
  					let subname = name[j];
  					subname = subname.toUpperCase();
					calcTotal.push(this.calcTotalNum(subname));
					calcKonsonant.push(this.calcKonsonantNum(subname));
					calcVocal.push(this.calcVocalNum(subname));
  				}

				this.total = calcTotal;
				this.totalDigits = this.sumDigits(calcTotal);


				this.konsonant = calcKonsonant;
				this.konsonantDigits = this.sumDigits(calcKonsonant);

				this.vocal = calcVocal;
				this.vocalDigits = this.sumDigits(calcVocal);
	  		},


	  		convertInput: function(){
  				this.calcNumbers(this.name);

  				let totalCalc = '';
  				for(var i=0; i < this.total.length; i++) {
	  				totalCalc += this.total[i]+'/'+this.totalDigits[i]+'<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>';
	  			}

	  			let konsonantCalc = '';
  				for(var i=0; i < this.konsonant.length; i++) {
	  				konsonantCalc += this.konsonant[i]+'/'+this.konsonantDigits[i]+'<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>';
	  			}

	  			let vocalCalc = '';
  				for(var i=0; i < this.vocal.length; i++) {
	  				vocalCalc += this.vocal[i]+'/'+this.vocalDigits[i]+'<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>';
	  			}

	  			// let hele = this.$el.querySelector('#hele');
	  			// let konsonant = this.$el.querySelector('#konsonant');
	  			// let vocal = this.$el.querySelector('#vocal');

	  			// hele.value = totalCalc;
	  			// konsonant.value = konsonantCalc;
	  			// vocal.value = vocalCalc;

	  			this.totalCalc = totalCalc;
	  			this.konsonantCalc = konsonantCalc;
	  			this.vocalCalc = vocalCalc;
	  		}
	  }

	}
</script>
<style scoped>

.numerologyContainer{
	width: 100%;
	max-width: 1250px;
	margin: 0 auto;
	position: relative;
	/*overflow: hidden;*/
}

.numerologyContainer h1{
	color: #5e74bc;
    font-size: 52px;
    font-weight: 300;
    padding-bottom: 5px;
    border-bottom: 1px solid #e0bf73;
}
.numerologyContainer p{
	color: #000000;
    font-size: 16px;
    font-weight: 300;
    padding-top: 10px;
    padding-bottom: 5px;
}

.numerologyContainer th{
	width: 56px;
	height: 56px;
	background: #5482CB;
	color: #fff;
	font-size: 24px;
	text-align: center;
	border: 4px solid #fff;
}

.numerologyContainer td{
	width: 56px;
	height: 56px;
	background: #E9F7F3;
	color: #36BC92;;
	font-size: 24px;
	font-weight: 300;
	text-align: center;
	border: 4px solid #fff;
}

.numerologyContainer input{
	max-width: 275px;
	color: #16255B;
	font-size: 22px;
	font-weight: bold;
	padding: 10px;
	border: 1px solid #36BC92;
	margin: 5px 0;
	display: inline-block;
    vertical-align: top;
}

.numerology-calc {
	color: #16255B;
	font-size: 24px;
	font-weight: initial;
	padding: 10px 0px;
	margin: 5px 0;
	vertical-align: top;
}

.numerology-calc p {
	font-size: 32px;
	font-weight: initial;
	color: #16255B;
}

.numerologyContainer input[type="text"]:disabled {
	background-color: initial;
	color: #16255B;
	font-size: 24px;
	font-weight: initial;
}

.numerologyContainer form {
    /*padding-top: 30px;*/
}

.numerologyContainer form > div {
    display: block;
}

.numerologyContainer form > div > div {
    display: inline-block;
}

.numerologyContainer form > div:first-child label {
    font-weight: bold;
    color: #000;
}

.numerologyContainer label {
	display: inline-block;
	color: #676767;
	font-size: 16px;
	font-weight: 300;
	line-height: 24px;
	margin: 20px auto;
	margin-bottom: 10px;
	vertical-align: middle;
    max-width: 180px;
	width: 100%;
}

.numerologyContainer input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
	color: #16255B;
	font-size: 24px;
	font-weight: bold;
}
::-moz-placeholder { /* Firefox 19+ */
	color: #16255B;
	font-size: 32px;
	font-weight: bold;
}
:-ms-input-placeholder { /* IE 10+ */
	color: #16255B;
	font-size: 32px;
	font-weight: bold;
}
:-moz-placeholder { /* Firefox 18- */
	color: #16255B;
	font-size: 32px;
	font-weight: bold;
}


@media only screen and (max-width: 1024px) {

	.numerologyContainer{
		width: calc(100% - 20px);
    	padding: 10px;
	}

	table{
		width: 100%;
	}


	th, td{
		border: 0 none;
	}



}


@media only screen and (max-width: 767px) {

	h1{
		font-size: 42px;
		margin: 0;
	}


}



</style>



// WEBPACK FOOTER //
// src/components/NumerologyComponent.vue